import React, { useEffect, useState } from 'react';
import { Calendar, Clock, User, Phone, Edit3, Trash2, CheckCircle, AlertTriangle, CreditCard, Truck, FileText, Shield, ChevronRight, MapPin, AlertCircle, Info } from 'lucide-react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { axiosInstance } from "../../utils/axios.js";
import Footer from '../../components/Footer';
import './mypage.scss';
import { FaCheckCircle } from "react-icons/fa";

const MypageReservationContainer = (props) => {
  const [currentReservations, setCurrentReservations] = useState([]);
  const [deliveryAddress, setDeliveryAddress] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const [idItem, setIdItem] = useState();
  const location = useLocation();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [expandedSteps, setExpandedSteps] = useState({});
  const [careplans, setCareplans] = useState({});
  const [isInsuranceConfirmedModalOpen, setIsInsuranceConfirmedModalOpen] = useState(false);


  const DateTimeComponent = ({ isoDate }) => {
    const date = new Date(isoDate);

    const formattedDate = date.toLocaleDateString('ja-JP', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      weekday: 'short',
    });

    const formattedTime = date.toLocaleTimeString('ja-JP', {
      hour: '2-digit',
      minute: '2-digit',
    });

    return (
      <div className="datetime_component">
        <Calendar className="datetime_icon" />
        <span>{formattedDate}</span>
        <Clock className="datetime_icon" />
        <span>{formattedTime}〜</span>
      </div>
    );
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const status = params.get('status');
    if (status === 'insurance_confirmed') {
      setIsInsuranceConfirmedModalOpen(true);
      // URLをクリーンにするために、パラメータを削除
      window.history.replaceState({}, document.title, window.location.pathname);
    } else if (status) {
      setIsModalOpen(true);
    }
  }, [location]);

  useEffect(() => {
    fetchReservations();
  }, []);

  const fetchReservations = () => {
    axiosInstance.get('/api/medichat/reservations', {
      headers: {
        'uid': props.token,
        'Access-Control-Allow-Origin': '*'
      }
    })
    .then(response => {
      setCurrentReservations(response.data.current_reservations || []);
      setIsLoading(false);
      setDeliveryAddress(response.data.address);

      const careplanData = {};
      response.data.current_reservations?.forEach(reservation => {
        if (reservation.careplan_info) {
          careplanData[reservation.id] = reservation.careplan_info;
        }
      });
      setCareplans(careplanData);

      console.log(response)

      // 各予約の現在のステップを自動展開
      const initialExpanded = {};
      response.data.current_reservations?.forEach(reservation => {
        if (reservation.current_step?.step) {
          initialExpanded[`${reservation.id}-${reservation.current_step.step - 1}`] = true;
        }
      });
      setExpandedSteps(initialExpanded);
    })
    .catch(error => {
      console.error("Error fetching reservations:", error);
      setIsLoading(false);
    });
  };

  const formatDateTime = (isoDate, addMinutes = 0) => { // addMinutesパラメータを追加
    const date = new Date(isoDate);
    if (addMinutes > 0) {
      date.setMinutes(date.getMinutes() + addMinutes); // 分を加算
    }

    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const weekdays = ['日', '月', '火', '水', '木', '金', '土'];
    const weekday = weekdays[date.getDay()];
    const hours = date.getHours().toString().padStart(2, '0'); // 2桁表示に
    const minutes = date.getMinutes().toString().padStart(2, '0'); // 2桁表示に

    return {
      date: `${year}年${month}月${day}日（${weekday}）`,
      time: `${hours}:${minutes}`
    };
  };

  const canReschedule = (reservation) => {
    const now = new Date();
    const reservationTime = new Date(reservation.start_time);
    const timeDiff = reservationTime.getTime() - now.getTime();
    const minutesDiff = timeDiff / (1000 * 60);
    return minutesDiff > 15;
  };

  // 診察が完了しているかチェック
  const isConsultationCompleted = (reservation) => {
    const consultationTask = reservation.reservation_tasks?.find(
      task => task.task_type_numeric === 0 || task.task_type === 'consultation'
    );
    return consultationTask?.is_completed || false;
  };

  const toggleStep = (element) => {
    const step = element.closest('.flow-step');
    const reservationId = step.getAttribute('data-reservation-id');
    const stepIndex = step.getAttribute('data-step-index');
    const key = `${reservationId}-${stepIndex}`;

    setExpandedSteps(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  // 改善されたステータス表示関数
  const getPatientFriendlyStatus = (adminStatus, taskType, responsibility, reservation, taskTags = []) => {
    const statusMap = {
      // 患者アクション必要
      '確認待ち': '保険証確認',
      '保険証情報確認待ち': '保険証情報確認待ち',
      '再送依頼中': '保険証を再度アップロード',
      '支払い待ち': 'お支払いをお願いします',
      'お支払い待ち': 'お支払いをお願いします',
      '療養計画書サイン待ち': 'サインをお願いします',
      '療養計画書アップロード済み': '署名待ち',

      // 患者は待機（運営処理中）
      '待機中': getWaitingMessage(taskType, reservation),
      '診察開始待ち': 'まもなく診察開始',
      '配送準備中': '発送準備中です',
      '配送中': '配送中です',
      '配送保留': '配送確認中です',
      '会計確定待ち': '会計処理中です',
      '会計保留': '会計確認中です',
      '診察中': '診察中です',
      '診察完了': '完了',
      '支払い完了': '完了',
      '発送完了': '完了',
      '配送完了': '完了',
      '療養計画書作成待ち': '書類準備中です',
      '在庫不足': '在庫確認中です',
      '返送（住所不定）': '住所確認が必要です'
    };

    return statusMap[adminStatus] || adminStatus;
  };

  // 保険証関連の詳細メッセージ取得
  const getInsuranceDetailMessage = (status, notes) => {
    const statusMessages = {
      '再送依頼中': {
        title: '保険証の再登録が必要です',
        description: '以下の理由により、保険証の再アップロードをお願いいたします。医療証をご利用の場合は、問診内で続けて確認します。',
        action: '新しい保険証画像をアップロードしてください。'
      },
      '確認待ち': {
        title: '保険証の登録が必要です',
        description: 'オンライン診療を受診するために、保険証の登録が必要です。医療証をご利用の場合は、問診内で任意で登録できます。',
        action: '保険証をアップロードしてください。'
      }
    };

    return statusMessages[status] || {
      title: '保険証の確認中',
      description: '保険証の内容を確認しています。',
      action: 'しばらくお待ちください。'
    };
  };

  // 会計関連の詳細メッセージ取得
  const getAccountingDetailMessage = (status, notes) => {
    const statusMessages = {
      '会計保留': {
        title: '会計内容を確認中です',
        description: '診療内容の確認を行っております。確認完了までしばらくお時間をいただきます。',
        action: 'ご不明な点がございましたら、お気軽にお問い合わせください。'
      },
      '支払い待ち': {
        title: 'お支払いをお願いします',
        description: '会計が確定いたしました。下記よりお支払いをお願いいたします。',
        action: 'お支払いボタンからお手続きください。'
      },
      '会計確定待ち': {
        title: '会計処理中です',
        description: '診療費の計算を行っております。確定次第お支払いが可能になります。',
        action: 'しばらくお待ちください。'
      }
    };

    return statusMessages[status] || {
      title: '会計確認中',
      description: '会計内容を確認しています。',
      action: 'しばらくお待ちください。'
    };
  };

  // 配送関連の詳細メッセージ取得
  const getDeliveryDetailMessage = (status, notes) => {
    const statusMessages = {
      '配送保留': {
        title: '配送に関してご確認ください',
        description: '大変申し訳ございませんが、配送に関して上記の問題が発生しております。',
        action: '大変お手数をおかけしますが、詳しい情報については「マイページ＞基本情報＞お問い合わせ」からご連絡ください。'
      },
      '配送準備中': {
        title: '発送準備中です',
        description: 'お薬の発送準備を行っております。',
        action: '準備完了次第、発送いたします。'
      },
      '配送中': {
        title: '配送中です',
        description: 'お薬を配送中です。1-2営業日でお届け予定です。',
        action: 'ご自宅のポストでお受け取りください。'
      },
      '在庫不足': {
        title: 'お薬の在庫不足',
        description: '大変申し訳ございませんが、配送に関して上記の問題が発生しております。',
        action: '大変お手数をおかけしますが、詳しい情報については「マイページ＞基本情報＞お問い合わせ」からご連絡ください。'
      },
      '返送（住所不定）': {
        title: '配送先住所の確認',
        description: '大変申し訳ございませんが、配送に関して上記の問題が発生しております。',
        action: '大変お手数をおかけしますが、詳しい情報については「マイページ＞基本情報＞お問い合わせ」からご連絡ください。'
      }
    };

    return statusMessages[status] || {
      title: '配送確認中',
      description: '配送に関して確認を行っております。',
      action: 'しばらくお待ちください。'
    };
  };

  // 書類関連の詳細メッセージ取得
  const getDocumentDetailMessage = (status, notes) => {
    const statusMessages = {
      '療養計画書サイン待ち': {
        title: 'サインをお願いします',
        description: '療養計画書の準備が完了いたしました。',
        action: 'メールまたはLINEでお送りした書類への署名をお願いいたします。'
      },
      '療養計画書作成待ち': {
        title: '書類準備中です',
        description: '療養計画書等の書類を準備しております。',
        action: '準備完了次第、ご連絡いたします。'
      }
    };

    return statusMessages[status] || {
      title: '書類準備中',
      description: '必要な書類を準備しております。',
      action: 'しばらくお待ちください。'
    };
  };

  // 待機メッセージの生成
  const getWaitingMessage = (taskType, reservation) => {
    switch(taskType) {
      case 'accounting':
        // 診察が終了している場合の判定
        if (reservation?.finish) {
          // 療養計画書タスクが存在し、未完了の場合
          const documentTask = reservation?.reservation_tasks?.find(t =>
            (t.task_type_numeric === 3 || t.task_type === 'document_creation') && !t.is_completed
          );
          return documentTask ? '療養計画書捺印後に開始' : 'お会計確認中';
        } else {
          // 診察がまだ終了していない場合
          return '診察終了後に開始';
        }
      case 'medicine_delivery':
        // 会計タスクの支払い状況を確認
        const accountingTask = reservation?.reservation_tasks?.find(t =>
          (t.task_type_numeric === 1 || t.task_type === 'accounting')
        );

        // 会計タスクが完了している場合は発送準備中、未完了の場合はお支払い待ち
        return accountingTask?.is_completed ? '発送準備中' : 'お支払い待ち';
      case 'document_creation':
        return '書類準備中';

      case 'insurance_card':
        return '診察完了後に開始';

      default:
        return '前のステップ完了後に開始';
    }
  };
  // 動的フロー生成（診察完了後の判定を追加）
  const generateFlowSteps = (reservation) => {
    const tasks = reservation.reservation_tasks || [];
    const orderedTasks = [];
    const isConsultationDone = isConsultationCompleted(reservation);

    // 1. 保険証登録
    const insuranceTask = tasks.find(t =>
      t.task_type_numeric === 4 || t.task_type === 'insurance_card'
    );
    if (insuranceTask) {
      orderedTasks.push({
        ...insuranceTask,
        taskInfo: { label: '保険証', icon: '🏥' },
        required: true
      });
    }

    // 2. 診察
    const consultationTask = tasks.find(t =>
      t.task_type_numeric === 0 || t.task_type === 'consultation'
    );
    if (consultationTask) {
      orderedTasks.push({
        ...consultationTask,
        taskInfo: { label: '診察', icon: '🩺' },
        required: true
      });
    }

    // 3. 書類作成（診察完了後に実際に存在する場合のみ）
    const documentTask = tasks.find(t =>
      t.task_type_numeric === 3 || t.task_type === 'document_creation'
    );
    if (documentTask) {
      orderedTasks.push({
        ...documentTask,
        taskInfo: { label: '療養計画書', icon: '📄' },
        required: isConsultationDone, // 診察完了後は必須扱い
        conditionalMessage: isConsultationDone ? null : '必要な場合'
      });
    }

    // 4. お会計
    const accountingTask = tasks.find(t =>
      t.task_type_numeric === 1 || t.task_type === 'accounting'
    );
    if (accountingTask) {
      orderedTasks.push({
        ...accountingTask,
        taskInfo: { label: 'お会計', icon: '💳' },
        required: true
      });
    }

    // 5. お薬受取（診察完了後に実際に存在する場合のみ）
    const medicineTask = tasks.find(t =>
      t.task_type_numeric === 2 || t.task_type === 'medicine_delivery'
    );
    if (medicineTask) {
      orderedTasks.push({
        ...medicineTask,
        taskInfo: { label: 'お薬', icon: '💊' },
        required: isConsultationDone, // 診察完了後は必須扱い
        conditionalMessage: isConsultationDone ? null : '必要な場合'
      });
    }

    return orderedTasks;
  };

  // 現在のステップ判定（新しい順序に対応）
  const getCurrentStep = (reservation) => {
    const steps = generateFlowSteps(reservation);

    // 未完了の最初のタスクを探す
    for (let i = 0; i < steps.length; i++) {
      if (!steps[i].is_completed) {
        return i;
      }
    }

    // 全て完了していたら最後のステップ
    return steps.length - 1;
  };

  // ステータスクラス判定（改善版）
  const getStatusClass = (task) => {
    if (!task) return 'status-upcoming';
    if (task.is_completed) return 'status-complete';

    // 患者アクション待ちかどうか
    const patientActionStatuses = [
      '確認待ち', '再送依頼中', '支払い待ち', 'お支払い待ち', '療養計画書サイン待ち', '療養計画書アップロード済み'
    ];

    // 保留状態
    const holdStatuses = [
      '配送保留', '会計保留'
    ];

    if (patientActionStatuses.includes(task.current_status)) {
      return 'status-warning'; // 患者アクション必要
    }

    if (holdStatuses.includes(task.current_status)) {
      return 'status-hold'; // 保留状態
    }

    return 'status-in-progress'; // 運営処理中
  };


  const getDisplayStatus = (taskTags, currentStatus) => {
    if (!taskTags || taskTags.length === 0) {
      return currentStatus;
    }

    // 最新のタグを使用（複数ある場合は最後のもの）
    const latestTag = taskTags[taskTags.length - 1];
    return latestTag.tag_name || latestTag;
  };

  // 修正されたrenderTaskStep関数
  const renderTaskStep = (task, index, reservation, isCurrentStep = false) => {
    if (!task) return null;

    const taskTypeValue = task.task_type_numeric || parseInt(task.task_type) || 0;
    const taskTags = task.task_tags || [];
    const status = getPatientFriendlyStatus(task.current_status, task.task_type, task.responsibility, reservation, taskTags);
    const stepKey = `${reservation.id}-${index}`;

    // 完了しているタスクは展開しない、現在のステップかつ未完了の場合のみ展開
    const isExpanded = !task.is_completed && (expandedSteps[stepKey] || isCurrentStep);

    // 既存のステータス判定を使用
    const getStepStatus = () => {
      if (task.is_completed) return { text: '完了', class: 'completed' };

      // 保留状態の特別処理
      if (['配送保留', '会計保留'].includes(task.current_status)) {
        return { text: status, class: 'hold' };
      }

      if (task.is_patient_waiting) return { text: status, class: 'waiting' };
      return { text: status, class: 'progress' };
    };

    const statusObj = getStepStatus();

    // 既存のクラス名 + 新しいクラス（条件付きの場合のみ）
    const stepClasses = [
      'flow-step',
      isCurrentStep ? 'current-step' : '',
      task.is_completed ? 'completed' : 'upcoming',
      isExpanded ? 'active' : '',
      !task.required ? 'conditional-step' : '' // 新しいクラスのみ追加
    ].filter(Boolean).join(' ');

    return (
      <li
        key={task.id || index}
        className={stepClasses}
        data-reservation-id={reservation.id}
        data-step-index={index}
      >
        <div className={`flow_step_header ${isCurrentStep ? 'flow_step_header_current' : ''} ${task.is_completed ? 'flow_step_header_completed' : ''}`}
             onClick={(e) => toggleStep(e.currentTarget)}>
          <div className={`flow_step_number ${isCurrentStep ? 'flow_step_number_current' : ''} ${task.is_completed ? 'flow_step_number_completed' : ''}`}>
            {task.is_completed ? '✓' : <span>{index + 1}</span>}
            {isCurrentStep && (
              <div className="flow_step_pulse" />
            )}
          </div>
          <div className="flow_step_content">
            <div>
            <span className="flow_step_icon" style={{marginRight:'6px'}}>{task.taskInfo.icon}</span>
            {task.taskInfo.label}
            </div>
            {/* 条件付きインジケーター（新規） */}
            {!task.required && (
              <span className="conditional-indicator">?</span>
            )}
            <span className={`flow_step_status ${statusObj.class}`}>
              {!task.required && !task.is_completed && task.conditionalMessage ?
                task.conditionalMessage : statusObj.text}
            </span>
          </div>
          <ChevronRight className={`flow_step_chevron ${isExpanded ? 'expanded' : ''}`} />
        </div>

        <div className={`flow_step_details ${isExpanded ? 'expanded' : ''}`}>
          <div className="flow_step_details_content">
            {renderTaskDetails(task, reservation, taskTypeValue, taskTags)}
          </div>
        </div>
      </li>
    );
  };

  const getStepStyles = (isCurrentStep, isCompleted, isExpanded) => {
    let className = 'flow_step_base';

    if (isCurrentStep) {
      className += ' flow_step_current';
    } else if (isCompleted) {
      className += ' flow_step_completed';
    } else if (isExpanded) {
      className += ' flow_step_expanded';
    }

    return className;
  };

  const getHeaderStyles = (isCurrentStep, isCompleted) => {
    let className = 'flow_step_header';

    if (isCurrentStep) {
      className += ' flow_step_header_current';
    } else if (isCompleted) {
      className += ' flow_step_header_completed';
    }
    return className;
  };

  const getStepNumberStyles = (isCurrentStep, isCompleted) => {
    let className = 'flow_step_number';

    if (isCurrentStep) {
      className += ' flow_step_number_current';
    } else if (isCompleted) {
      className += ' flow_step_number_completed';
    }

    return className;
  };

  const handleInsuranceRegistration = () => {
    navigate('/medichat/mypage/insurance');
  };

  const handleAddressChange = () => {
    navigate('/mypage/other/address');
  };

  const renderInsuranceNotice = () => {
    // 保険証が必要な予約を取得
    const reservationsNeedingInsurance = currentReservations.filter(reservation => {
      const insuranceTask = reservation.reservation_tasks?.find(
        task => (task.task_type_numeric === 4 || task.task_type === 'insurance_card') && !task.is_completed
      );
      return insuranceTask && insuranceTask.is_patient_waiting;
    });
  
    if (reservationsNeedingInsurance.length === 0) return null;
  
    // 再診で確認待ちの予約があるかチェック
    const hasReturnVisitWaitingConfirmation = reservationsNeedingInsurance.some(reservation => {
      const insuranceTask = reservation.reservation_tasks?.find(
        task => (task.task_type_numeric === 4 || task.task_type === 'insurance_card') && !task.is_completed
      );
      return !reservation.first && 
             (insuranceTask.current_status === '確認待ち' || insuranceTask.current_status === '再送依頼中' ) && 
             insuranceTask.is_patient_waiting;
    });
  
    // 再診で確認待ちの場合は表示しない（タスク詳細で変更確認ボタンが表示されるため）
    if (hasReturnVisitWaitingConfirmation) return null;
  
    // 初診または通常の保険証登録が必要な場合のみ表示
    return (
      <div className="info_section">
        <h3 className="info_title">
          🏥 保険証/医療証をご確認ください
        </h3>
        <div className="info_content">
          <p>オンライン診療を受診するために、事前に保険証/資格確認書の登録が必要です。医療証をご利用の場合はあわせてご確認ください。</p>
          <p className="task_link_note">
            <a href="https://grey-brow-5dc.notion.site/210a4be0fa7080cd954fefcb5e8f4931" className="task_link_secondary">
              📱 マイナ保険証のスクリーンショット取得方法
            </a>
          </p>
          <p className="task_note" style={{ color: '#F57C00' }}>
            ⚠️ 診療開始30分前までに保険証登録を完了してください。
          </p>
        </div>
        <button className="btn_primary" onClick={handleInsuranceRegistration}>
          📋 保険証・医療証を確認する
        </button>
      </div>
    );
  };

  const renderDeliveryAddressSection = () => {
    if (!deliveryAddress) return null;

    return (
      <div className="delivery_section">
        <div className="delivery_section_header">
          <h3 className="delivery_title">
            <MapPin size={20} />
            配送先住所
          </h3>
          <p
            className="delivery_change_link"
            onClick={handleAddressChange}
          >
            変更がある場合はこちら
          </p>
        </div>
        <div className="delivery_address">
          <div>〒{deliveryAddress.zip}</div>
          <div>{deliveryAddress.address}</div>
          {deliveryAddress.apartment && <div>{deliveryAddress.apartment}</div>}
        </div>
      </div>
    );
  };

  // 改善されたタスク詳細表示
  const renderTaskDetails = (task, reservation, taskType, taskTags = []) => {
    switch(taskType) {
      case 0: // 診察
        return (
          <div>
            <p>診察時間の5分前になりましたら、下記「診察待合室」ボタンから入室して診察開始までお待ちください。</p>
              {/* ボタンの表示制御 */}
                        {!task.is_completed && (
              <button
                className={`primary_action_button ${!task.is_completed ? '' : 'btn_disabled'}`}
                disabled={reservation.finish}
                onClick={() => window.location.href = reservation.admin_user.zoom_url}
                >
                📞 診察待合室に入る
              </button>
            )}

            <div className="task_info_box">
              💡 LINEに送られたZoomURLからも診察待合室に入室いただけます。
            </div>

            <p className="task_note">
              ※万が一つながらない場合は
              <a href="https://customer-service-flame.vercel.app/auth" className="task_link">リカレ医療グループ窓口</a>
              にお問合せください。
            </p>

          </div>
        );

// renderTaskDetails関数内のcase 4: // 保険証の部分を修正

case 4: // 保険証
  const insuranceMessage = getInsuranceDetailMessage(task.current_status, task.notes);
  
  // 再診で確認待ちかどうかを判定
  const isReturnVisitWaitingConfirmation = !reservation.first && 
    (task.current_status === '確認待ち' || task.current_status === '再送依頼中') && 
    task.is_patient_waiting;
  
  return (
    <div>
      {isReturnVisitWaitingConfirmation ? (
        // 再診で確認待ちの場合：変更確認ボタンのみ表示
        <>
          <p>前回ご提出いただいた保険証に変更があるかどうかをご確認ください。変更がない場合は、前回の保険証情報を引き継ぎます。医療証をご利用の場合は、問診内で続けて確認します。</p>


          <button
            className="btn_primary"
            onClick={() => navigate('/medichat/mypage/insurance')}
          >
            📋 保険証・医療証の確認へ進む
          </button>
        </>
      ) : (
        // 初診または通常の保険証登録の場合：従来の表示
        <>
          <p>オンライン診療には保険証/資格確認書の登録が必要です。医療証をご利用の場合はあわせてご確認ください。まだ登録がお済みでない場合は、下記より保険証/医療証ページへ進んでください。</p>

          {/* 保険証関連の詳細メッセージ */}
          {(task.current_status === '再送依頼中' || task.current_status === '確認待ち') && task.is_patient_waiting && (
            <div className="task_hold_box insurance">
              <div className="task_detail_content">
                <div className="status_info_row">
                  <AlertCircle size={20} style={{color: '#D32F2F', marginRight: '8px'}} />
                  <strong>{getDisplayStatus(taskTags, task.current_status)}
                    {task.notes && (
                        <span className="notes_value" style={{marginLeft:'6px'}}>{task.notes}</span>
                    )}
                  </strong>
                </div>
                  <div className="message_content">
                      <strong>{insuranceMessage.title}</strong>
                      <p>{insuranceMessage.description}</p>
                      <p className="action_guidance">{insuranceMessage.action}</p>
                  </div>
              </div>
            </div>
          )}

          {/* 完了していない場合のみボタンを表示 */}
          {!task.is_completed && (
            <button
              className={`btn_primary ${task.is_patient_waiting ? '' : 'btn_disabled'}`}
              disabled={!task.is_patient_waiting}
              onClick={() => task.is_patient_waiting && handleInsuranceRegistration()}
            >
              📋 保険証・医療証を確認する
            </button>
          )}

          <p className="task_link_note">
            <a href="https://grey-brow-5dc.notion.site/210a4be0fa7080cd954fefcb5e8f4931" className="task_link_secondary">
              📱 マイナ保険証のスクリーンショット取得方法
            </a>
          </p>
        </>
      )}
    </div>
  );
      case 1: // 会計
        const accountingMessage = getAccountingDetailMessage(task.current_status, task.notes);
        return (
          <div>
            <p>診察お疲れ様でした。今回のお会計を確認しております。確定後にお支払いが可能になりますので、しばらくお待ちください。</p>

            {/* 会計関連の詳細メッセージ */}
            {['会計保留','会計再度確定', '会計確定待ち'].includes(task.current_status) && (
              <div className={`task_hold_box accounting ${task.current_status === '支払い待ち' ? 'patient-action' : 'clinic-action'}`}>
                <div className="task_detail_content">
                  <div className="status_info_row">
                      {task.current_status === '支払い待ち' ? (
                      <CreditCard size={20} style={{color: '#D32F2F', marginRight: '8px'}} />
                    ) : (
                      <Info size={20} style={{color: '#F57C00', marginRight: '8px'}} />
                    )}
                    <strong>{getDisplayStatus(taskTags, task.current_status)}
                      {task.notes && (
                          <span className="notes_value" style={{marginLeft:'6px'}}>{task.notes}</span>
                      )}
                    </strong>
                  </div>
                  <div className="message_content">
                    <strong>{accountingMessage.title}</strong>
                    <p>{accountingMessage.description}</p>
                    <p className="action_guidance">{accountingMessage.action}</p>
                  </div>
                </div>
              </div>
            )}

            {/* 完了していない場合のみボタンを表示 */}
            {!task.is_completed && (
              <>
                {task.is_patient_waiting && task.current_status === '支払い待ち' && (
                  <p className="task_payment_note">
                    👇 下記ボタンからもお支払いできます
                  </p>
                )}

                <button
                  className={`btn_primary ${task.is_patient_waiting ? '' : 'btn_disabled'}`}
                  disabled={!task.is_patient_waiting}
                  onClick={() => task.is_patient_waiting && navigate(`/mypage/payment/bill/${reservation.id}`)}
                >
                  💳 {task.is_patient_waiting ? 'お支払いをする' :
                       ['会計保留', '会計確定待ち'].includes(task.current_status) ? '確認中です' : '会計確認中'}
                </button>
              </>
            )}
          </div>
        );

      case 2: // 薬配送
        const deliveryMessage = getDeliveryDetailMessage(task.current_status, task.notes);
        return (
          <div>
            <p>お支払いが完了次第、順次お薬の発送手続きをさせていただきます。ご自宅のポスト等でお受け取りください。</p>

            {/* 配送関連の詳細メッセージ */}
            {['配送保留', '在庫不足', '返送（住所不定）', '配送中'].includes(task.current_status) && (
              <div className={`task_hold_box delivery ${task.current_status === '返送（住所不定）' ? 'patient-action' : 'clinic-action'}`}>
                <div className="task_detail_content">
                  <div className="status_info_row">
                  {task.current_status === '返送（住所不定）' ? (
                    <AlertTriangle size={20} style={{color: '#D32F2F', marginRight: '8px'}} />
                  ) : task.current_status === '配送中' ? (
                    <Truck size={20} style={{color: '#4CAF50', marginRight: '8px'}} />
                  ) : (
                    <Info size={20} style={{color: '#F57C00', marginRight: '8px'}} />
                  )}
                    <strong>{getDisplayStatus(taskTags, task.current_status)}
                      {task.notes && (
                          <span className="notes_value" style={{marginLeft:'6px'}}>{task.notes}</span>
                      )}
                    </strong>
                  </div>
                  <div className="message_content" style={{marginTop:'12px'}}>
                    <p>{deliveryMessage.description}</p>
                    <p className="action_guidance">{deliveryMessage.action}</p>
                  </div>
                  {task.current_status === '返送（住所不定）' && (
                    <div style={{marginTop: '12px'}}>
                      <button
                        className="address-change-button"
                        onClick={handleAddressChange}
                      >
                        📍 住所を確認・変更する
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* 配送状況確認ボタンは配送開始後に表示 */}
            {['配送中', '発送完了', '配送完了'].includes(task.current_status) && (
              <button
                className="btn_delivery_track"
                disabled={!task.is_completed}
              >
                📦 配送状況を確認する
              </button>
            )}
          </div>
        );

        case 3: // 書類
        const documentMessage = getDocumentDetailMessage(task.current_status, task.notes);
        const careplan = careplans[reservation.id]
        return (
          <div>
            {!task.is_completed && task.current_status === '療養計画書アップロード済み'
              ? <p>療養計画書の作成が完了しました。以下のボタンからご確認の上、ご捺印ください。</p>
              : <p>療養計画書の確認と捺印が必要です。ただいま準備中ですので少々お待ちください。</p>
            }

            {/* 書類関連の詳細メッセージ */}
            {['療養計画書サイン待ち', '療養計画書作成待ち'].includes(task.current_status) && (
              <div className={`task_hold_box document ${(task.current_status === '療養計画書サイン待ち' || task.current_status === '療養計画書アップロード済み') ? 'patient-action' : 'clinic-action'}`}>
                <div className="task_detail_content">
                  <div className="status_info_row">
                      {(task.current_status === '療養計画書サイン待ち' || task.current_status === '療養計画書アップロード済み') ? (
                      <FileText size={20} style={{color: '#D32F2F', marginRight: '8px'}} />
                    ) : (
                      <Info size={20} style={{color: '#F57C00', marginRight: '8px'}} />
                    )}
                    <strong>{getDisplayStatus(taskTags, task.current_status)}
                      {task.notes && (
                          <span className="notes_value" style={{marginLeft:'6px'}}>{task.notes}</span>
                      )}
                    </strong>
                  </div>
                  {task.current_status === '療養計画書サイン待ち' && (
                    <div className="message_content">
                      <strong>{documentMessage.title}</strong>
                      <p>{documentMessage.description}</p>
                      <p className="action_guidance">{documentMessage.action}</p>
                    </div>
                  )}
                  {task.current_status === '療養計画書作成待ち' && (
                    <div className="message_content">
                      <strong>{documentMessage.title}</strong>
                      <p>{documentMessage.description}</p>
                      <p className="action_guidance">{documentMessage.action}</p>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* 承認ボタン（療養計画書アップロード済みの場合のみ） */}
            {!task.is_completed && task.current_status === '療養計画書アップロード済み' && (
              <button
                className="careplan_approval_button"
                onClick={() => window.location.href = careplan.document_url}
              >
                ✍️ 療養計画書を署名する
              </button>
            )}

          </div>
        );

      default:
        return <p>{task.current_status || '処理中'}</p>;
    }
  };

  const cancel_app = () => {
    setIsLoading(true);
    axiosInstance.put(`/reservations/${idItem}`, {}, {
      headers: {
        'uid': props.token,
        'Access-Control-Allow-Origin': '*'
      }
    })
    .then(response => {
      setShowModal(false);
      setCancelModal(true);
      fetchReservations();
    })
    .catch(error => {
      console.error("キャンセルリクエストが失敗しました:", error);
      setIsLoading(false);
    });
  };

  const openModal = (id) => {
    setShowModal(true);
    setIdItem(id);
  };

  const closeModal = () => {
    setShowModal(false);
    setCancelModal(false);
    setIsModalOpen(false);
  };

  const getCurrentActionButton = (reservation) => {
    if (!reservation.current_step?.task) return null;

    const task = reservation.current_step.task;
    const taskType = task.task_type_numeric || parseInt(task.task_type) || 0;

    // 診察タスクが未完了の場合
    if (!task.is_completed) {
      return (
        <button
          className="primary_action_button"
          onClick={() => window.location.href = reservation.admin_user.zoom_url}
        >
          📞 診察待合室に入る
        </button>
      );
    }

    // 会計タスクで支払い待ちの場合
    if (taskType === 1 && task.current_status === '支払い待ち') {
      return (
        <NavLink to={`/mypage/payment/bill/${reservation.id}`} className="primary_action_button">
          💳 お支払いへ
        </NavLink>
      );
    }

    return null;
  };

  if (isLoading) {
    return (
      <div>
        <div className="loader" style={{ width: '100px', height: '100px' }}></div>
        <div
          style={{
            width: '100%',
            position: 'absolute',
            bottom: '0%',
            height: '80px',
            background: '#FEFBF9',
            zIndex: '12',
          }}
        />
      </div>
    );
  }

  return (
    <div className="sunny_container">
      {/* メインコンテンツ */}
      <div className="reservation_main_content" style={{paddingBottom:'140px',paddingTop:'40px'}}>
        {currentReservations.length === 0 ? (
            <div className="mypage_reservation_now_reservations" style={{width:'80%'}}>
            <Calendar className="empty_icon" />
            <p>予約中の診察はありません</p>
          </div>
        ) : (
            <>
            {currentReservations.map((reservation, reservationIndex) => {
              const dateTime = formatDateTime(reservation.start_time);
              const endTime = reservation.first
                ? formatDateTime(reservation.start_time, 15).time
                : formatDateTime(reservation.start_time, 10).time;
  
              const flowSteps = generateFlowSteps(reservation); // 新しい順序のタスク
              const currentStepIndex = getCurrentStep(reservation);
              const consultationCompleted = isConsultationCompleted(reservation);
              
              // 最初の予約のみ詳細表示、2つ目以降は基本カードのみ
              const isFirstReservation = reservationIndex === 0;
  
              return (
                <div key={reservation.id}>
                  {/* 予約カード（全ての予約で表示） */}
                  <div className="reservation_card">
                    {/* 医師情報セクション */}
                    <div className="doctor_section">
                      <div className="doctor_avatar">
                        👨‍⚕️
                      </div>
                      <div className="doctor_info">
                        <div className="doctor_name">
                          担当医: {reservation.admin_user?.lastname}先生
                        </div>
                      </div>
                    </div>
  
                    {/* 予約日時セクション */}
                    <div className="appointment_section">
                      <div className="appointment_date">
                        {dateTime.date}
                      </div>
                      <div className="appointment_time">
                        {dateTime.time}〜{endTime}
                      </div>
                    </div>
  
                    {/* メインアクションボタン（診察完了時は非表示） */}
                    {!consultationCompleted && getCurrentActionButton(reservation)}
  
                    {!consultationCompleted && (
                      <div className="primary_action_note">
                        ※診療時間の5分前からご利用いただけます
                      </div>
                    )}
  
                    {/* セカンダリアクション（診察完了時は非表示） */}
                    {!consultationCompleted && (
                      <div className="secondary_actions">
                        {canReschedule(reservation) ? (
                          <NavLink to={`/reservations/${reservation.id}/reschedule`} className="secondary_button">
                            <Edit3 size={16} />
                            予約変更
                          </NavLink>
                        ) : (
                          <button className="secondary_button" disabled>
                            <Edit3 size={16} />
                            予約変更
                          </button>
                        )}
                        <button
                          className="cancel_button"
                          onClick={() => openModal(reservation.id)}
                        >
                          <Trash2 size={16} />
                          キャンセル
                        </button>
                      </div>
                    )}
                  </div>
  
                  {/* 以下のセクションは最初の予約のみ表示 */}
                  {isFirstReservation && (
                    <div style={{marginBottom:'12px'}}>
                      {/* 配送先住所セクション */}
                      {renderDeliveryAddressSection()}
                      
                      {/* 保険証登録通知 */}
                      {renderInsuranceNotice()}
  
                      {/* 診療の流れ（タスクの順序のみ変更） */}
                      <div className="flow_section">
                        <h3 className="flow_title">
                          📋 オンライン診療の流れ
                        </h3>
  
                        <ul className="flow_steps">
                          {flowSteps.map((task, index) => renderTaskStep(
                            task,
                            index,
                            reservation,
                            index === currentStepIndex
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </>
        )}
  
        {/* モーダル類 */}
        {showModal && (
          <div className="modal_overlay" onClick={closeModal}>
            <div className="modal_content" onClick={(e) => e.stopPropagation()}>
              <button className="close_button" onClick={closeModal}>✖︎</button>
              <div className="modal_icon warning_icon">
                <Trash2 size={36} />
              </div>
              <p className="modal_title">予約をキャンセルしますか？</p>
              <p className="modal_subtitle">※当日キャンセルの場合キャンセル料が発生しますのでご注意ください。</p>
              <div className="multi_button">
                <button className="multi_button_right" onClick={cancel_app}>
                  {isLoading ? '処理中...' : 'はい'}
                </button>
                <button className="multi_button_left" onClick={closeModal}>いいえ</button>
              </div>
            </div>
          </div>
        )}
  
        {cancelModal && (
          <div className="modal_overlay" onClick={() => setCancelModal(false)}>
            <div className="modal_content" onClick={(e) => e.stopPropagation()}>
              <button className="close_button" onClick={() => setCancelModal(false)}>✖︎</button>
              <div className="modal_icon success_icon">
                <CheckCircle size={36} />
              </div>
              <p className="modal_title">キャンセル完了</p>
              <p className="modal_subtitle">またのご予約をお待ちしております。</p>
            </div>
          </div>
        )}

        {isInsuranceConfirmedModalOpen && (
          <div className="modal-overlay" onClick={() => setIsInsuranceConfirmedModalOpen(false)}>
            <div className="modal-content success_modal" onClick={(e) => e.stopPropagation()}>
              <span className="close-button" onClick={() => setIsInsuranceConfirmedModalOpen(false)}>✖︎</span>
              <div className="mordal_done">
                <FaCheckCircle className="mordal_done_check"/>
                <p className="mordal_done_check_title">
                  保険証確認が完了しました
                </p>
                <div className="mordal_done_check_container">
                  <p style={{fontSize:'14px'}}>前回の保険証情報が引き継がれました。引き続き診療の流れをご確認ください。</p>
                </div>
              </div>
            </div>
          </div>
        )}
        {isModalOpen && (
          <div className="modal-overlay" onClick={() => closeModal(false)}>
            <div className="modal-content success_modal" onClick={(e) => e.stopPropagation()}>
              <span className="close-button" onClick={() => closeModal(false)}>✖︎</span>
              <div className="mordal_done">
                <FaCheckCircle className="mordal_done_check"/>
                  <p className="mordal_done_check_title">
                    {(() => {
                      const params = new URLSearchParams(location.search);
                      const status = params.get('status');
                      if (status === 'reschedule_success') {
                        return '予約変更が完了しました';
                      } else {
                        return '診察予約が完了しました';
                      }
                    })()}
                  </p>
                  <div className="mordal_done_check_container">
                    <p style={{fontSize:'14px'}}>診察開始5分前に診察室にお入りください。当日キャンセル・無断キャンセルにはキャンセル料がかかりますのでご注意ください。</p>
                  </div>
                </div>
              </div>
            </div>
          )}
      </div>
      <Footer />
    </div>
  );
};

export default MypageReservationContainer;
